import React, { useEffect, useMemo, useState } from 'react';
import { Row, Form, message } from 'antd';
import moment from 'moment';
import * as S from './styles';
import EditForm from '../../../components/EditForm';
import api from '../../../services/api';
import { toDate, setMaskTelefone } from '../../../helpers/utils';
import { getEstadosList } from '../../../services/estado';
import { foneMask, dateMask, cepMask } from '../../../helpers/helpersEditForm';

export function DadosParaEdicao({
  dadosMotorista,
  setReadOnly,
  carregarSolicitacaoAtual,
  setSpinning,
}) {
  const [form] = Form.useForm();

  const [listUF, setListUF] = useState([]);

  const initialState = async () => {
    try {
      const response = await getEstadosList();
      setListUF(response.items);
    } catch (error) {}
  };
  useEffect(() => {
    initialState();
  }, []);

  const salvarEdicao = async form => {
    const naturalidadeCodigoENome = String(form.cidadeNascimentoFundacao).split(
      '#'
    );

    const cidadeCnhCodigoENome = String(form.cidadecnh).split('#');

    let ibgeCidadeNascimento = form.cidadeNascimentoFundacao
      ? dadosMotorista?.ibgeCidadeNascimento ?? null
      : null;
    if (/^\d+$/.test(String(form.cidadeNascimentoFundacao))) {
      ibgeCidadeNascimento = form.cidadeNascimentoFundacao;
    }
    let naturalidade = form.cidadeNascimentoFundacao
      ? dadosMotorista?.naturalidade
      : null;
    if (naturalidadeCodigoENome.length === 2) {
      ibgeCidadeNascimento = naturalidadeCodigoENome[0];
      naturalidade = naturalidadeCodigoENome[1];
    }

    let codigoIbgeMunicipio = form.cidadecnh || null;
    if (cidadeCnhCodigoENome.length === 2) {
      codigoIbgeMunicipio = cidadeCnhCodigoENome[0];
    }

    const arrayCodigoIbgeENome = String(form.cidadeEndereco).split('#');
    let codigoIBGECidade = form.cidadeEndereco || null;
    let cidade = form.cidadeEndereco
      ? dadosMotorista?.dadosEndereco?.nomeMunicipio
      : null;
    if (arrayCodigoIbgeENome.length === 2) {
      codigoIBGECidade = arrayCodigoIbgeENome[0];
      cidade = arrayCodigoIbgeENome[1];
    }

    const {
      endereco,
      dadosEndereco,
      referencias,
      telefone,
      ...pessoaFisica
    } = dadosMotorista;
    const payload = {
      documento: form.cpf.replace(/[^\d]+/g, ''),
      telefone: form.telefone,
      idTipoCadastro: 1,
      pessoaFisicaCadastro: {
        ...pessoaFisica,
        cpf: form.cpf.replace(/[^\d]+/g, ''),
        nome: form.nome,
        nomeMae: form.nomeMae,
        nomePai: form.nomePai,
        motoristaCadastro: {
          ...dadosMotorista?.motoristaCadastro,
          numeroRegistroCNH: form.numeroCNH,
          categoriaCNH: form.categoria,
          codigoSegurancaCNH: form.codCNH,
          numeroFormularioCNH: form.formularioCNH,
          ufEmissaoCNH: form.ufcnh,
          dataEmissaoCNH: toDate(form.emissaoCNH || null),
          dataValidadeCNH: toDate(form.validadeCNH || null),
          emissaoPrimeiraCNH: toDate(form.emissaoPrimeiraCNH || null),
          codigoIbgeMunicipio,
        },
        ibgeCidadeNascimento,
        naturalidade,
        ufNascimento: form.ufNascimentoFundacao,
        numeroRG: form.rg,
        dataEmissaoRG: toDate(form.dataEmissaoRG || null),
        ufrg: form.ufrg,
        dataNascimentoStr: form.nascimento,
        dataNascimento: toDate(form.nascimento || null),
      },
      dadosEndereco: {
        ...dadosEndereco,
        codigoIbgeMunicipio: codigoIBGECidade,
        nomeMunicipio: cidade,
        endereco: form.endereco,
        numero: form.numero,
        complemento: form.complemento,
        uf: form.ufEndereco,
        bairro: form.bairro,
        cep: form.cep,
      },
      referencias,
    };
    setSpinning(true);
    try {
      const response = await api.post('pessoa', payload);
      await carregarSolicitacaoAtual();
      setReadOnly(true);
      return response;
    } catch (error) {
      message.error(
        error?.response?.data?.detail || 'Não foi possível salvar o motorista.'
      );
      return error;
    } finally {
      setSpinning(false);
    }
  };

  const formItems = useMemo(
    () => [
      {
        nome: 'nome',
        label: 'Nome',
        initialValue: dadosMotorista?.nome,
        width: '98.7%',
      },
      {
        nome: 'cpf',
        label: 'CPF',
        labelColor: '#B2BBBF',
        initialValue: dadosMotorista?.cpfFormatado || dadosMotorista?.cpf,
        width: '32%',
        bloqueado: true,
        border: '1px solid #EFEFEF',
      },
      {
        nome: 'nascimento',
        label: 'Data de Nascimento',
        initialValue:
          (!!dadosMotorista?.dataNascimento &&
            moment(dadosMotorista?.dataNascimento).format('DD/MM/YYYY')) ||
          '',
        width: '32%',
        onChange: e => dateMask(e.target.value, form, 'nascimento'),
      },
      {
        nome: 'telefone',
        label: 'Telefone',
        initialValue: setMaskTelefone(dadosMotorista?.telefone),
        width: '32%',
        onChange: e => foneMask(e.target.value, form, 'telefone'),
      },
      {
        nome: 'categoria',
        label: 'Categoria',
        initialValue: dadosMotorista?.motoristaCadastro?.categoriaCNH,
        width: '32%',
      },
      {
        firstId: 'ufcnh',
        secondId: 'cidadecnh',
        select: 'double',
        nome: 'ufcnh',
        firstLabel: 'UF CNH',
        secondLabel: 'Cidade CNH',
        firstInitialValue: dadosMotorista?.motoristaCadastro?.ufEmissaoCNH,
        secondInitialValue:
          dadosMotorista?.motoristaCadastro?.codigoIbgeMunicipio,
        width: '65%',
      },
      {
        firstId: 'ufNascimentoFundacao',
        secondId: 'cidadeNascimentoFundacao',
        select: 'double',
        nome: 'naturalidade',
        firstLabel: 'Naturalidade UF',
        secondLabel: 'Naturalidade Cidade',
        firstInitialValue: dadosMotorista?.ufNascimento || dadosMotorista?.ufrg,
        width: '65%',
        secondInitialValue:
          dadosMotorista?.ibgeCidadeNascimento || dadosMotorista?.naturalidade,
      },
      {
        nome: 'nomeMae',
        label: 'Nome da Mãe',
        initialValue: dadosMotorista?.nomeMae,
        width: '98.7%',
      },
      {
        nome: 'nomePai',
        label: 'Nome do Pai',
        initialValue: dadosMotorista?.nomePai,
        width: '98.7%',
      },
      {
        nome: 'rg',
        label: 'RG',
        initialValue: dadosMotorista?.numeroRG,
        width: '32%',
      },
      {
        nome: 'dataEmissaoRG',
        label: 'Data de emissão RG',
        initialValue:
          (!!dadosMotorista?.dataEmissaoRG &&
            moment(dadosMotorista?.dataEmissaoRG).format('DD/MM/YYYY')) ||
          null,
        width: '32%',
        onChange: e => dateMask(e.target.value, form, 'dataEmissaoRG'),
      },
      {
        select: 'single',
        nome: 'ufrg',
        label: 'UF RG',
        initialValue: dadosMotorista?.ufrg,
        width: '32%',
      },
      {
        nome: 'formularioCNH',
        label: 'Formulário CNH',
        initialValue: dadosMotorista?.motoristaCadastro?.numeroFormularioCNH,
        width: '32%',
      },
      {
        nome: 'numeroCNH',
        label: 'Nº de registro CNH',
        initialValue: dadosMotorista?.motoristaCadastro?.numeroRegistroCNH,
        width: '32%',
      },
      {
        nome: 'emissaoCNH',
        label: 'Emissão CNH',
        initialValue:
          (!!dadosMotorista?.motoristaCadastro?.dataEmissaoCNH &&
            moment(dadosMotorista?.motoristaCadastro?.dataEmissaoCNH).format(
              'DD/MM/YYYY'
            )) ||
          null,
        width: '32%',
        onChange: e => dateMask(e.target.value, form, 'emissaoCNH'),
      },
      {
        nome: 'validadeCNH',
        label: 'Validade CNH',
        initialValue:
          (!!dadosMotorista?.motoristaCadastro?.dataValidadeCNH &&
            moment(dadosMotorista?.motoristaCadastro?.dataValidadeCNH).format(
              'DD/MM/YYYY'
            )) ||
          null,
        width: '32%',
        onChange: e => dateMask(e.target.value, form, 'validadeCNH'),
      },
      {
        nome: 'codCNH',
        label: 'Cod. de segurança CNH',
        initialValue: dadosMotorista?.motoristaCadastro?.codigoSegurancaCNH,
        width: '32%',
      },
      {
        nome: 'emissaoPrimeiraCNH',
        label: 'Data emissão primeira CNH',
        initialValue:
          (!!dadosMotorista?.motoristaCadastro?.emissaoPrimeiraCNH &&
            moment(
              dadosMotorista?.motoristaCadastro?.emissaoPrimeiraCNH
            ).format('DD/MM/YYYY')) ||
          null,
        width: '32%',
        onChange: e => dateMask(e.target.value, form, 'emissaoPrimeiraCNH'),
      },
      {
        label: 'Endereço',
        nome: 'endereco',
        width: '98.7%',
        initialValue: dadosMotorista?.dadosEndereco?.endereco,
      },
      {
        label: 'Número',
        nome: 'numero',
        width: '32%',
        initialValue: dadosMotorista?.dadosEndereco?.numero,
      },
      {
        label: 'Complemento',
        nome: 'complemento',
        width: '32%',
        initialValue: dadosMotorista?.dadosEndereco?.complemento,
      },
      {
        label: 'Bairro',
        nome: 'bairro',
        width: '32%',
        initialValue: dadosMotorista?.dadosEndereco?.bairro,
      },
      {
        label: 'Cep',
        nome: 'cep',
        width: '32%',
        initialValue: dadosMotorista?.dadosEndereco?.cep,
        onChange: e => cepMask(e, form, 'cep'),
      },
      {
        firstId: 'ufEndereco',
        secondId: 'cidadeEndereco',
        select: 'double',
        nome: 'cidadeEndereco',
        firstLabel: 'UF',
        secondLabel: 'Município',
        firstInitialValue: dadosMotorista?.dadosEndereco?.uf,
        width: '65%',
        secondInitialValue: dadosMotorista?.dadosEndereco?.codigoIbgeMunicipio,
      },
    ],
    [dadosMotorista, form]
  );

  useEffect(() => {
    const values = {};
    formItems.forEach(item => {
      if (item.select === 'double') {
        values[item.firstId] = item.firstInitialValue ?? null;
        values[item.secondId] = item.secondInitialValue ?? null;
      } else {
        values[item.nome] = item.initialValue ?? '';
      }
    });
    form.setFieldsValue(values);
  }, [form, formItems]);

  return (
    <Row
      justify="space-between"
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        marginTop: 32,
      }}
    >
      <Form form={form} layout="vertical" onFinish={form => salvarEdicao(form)}>
        <S.DivItems>
          {formItems.map(item => (
            <EditForm
              key={item.nome}
              list={listUF}
              item={{ ...item, list: listUF }}
              form={form}
            />
          ))}
        </S.DivItems>
        <S.DivButtons>
          <Form.Item>
            <S.ButtonCancelar type="button" onClick={() => setReadOnly(true)}>
              Cancelar
            </S.ButtonCancelar>
          </Form.Item>
          <Form.Item>
            <S.ButtonSalvar type="submit">Salvar</S.ButtonSalvar>
          </Form.Item>
        </S.DivButtons>
      </Form>
    </Row>
  );
}
